import { render, staticRenderFns } from "./userInte.vue?vue&type=template&id=249ba40e&scoped=true"
import script from "./userInte.vue?vue&type=script&lang=js"
export * from "./userInte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249ba40e",
  null
  
)

export default component.exports